// StoreUsersList.tsx - With Add Employee functionality
import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import EmployeeTable from "../Employees/EmployeeListTable";
import NoEmployeeListFound from "../Employees/NoEmployeeListFound";
import AddEmployeeModal from "../Employees/AddEmployeeModal";
import { Employee } from "../Employees/types/employees";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

interface Props {
  storesEmployees: Employee[];
  storeId?: string; // Optional: to pre-populate store in modal
}

const StoreEmployeeList: React.FC<Props> = ({ storesEmployees }) => {
  const { t } = useKivunovaTranslation();
  const [openAddModal, setOpenAddModal] = useState(false);

  if (!storesEmployees.length) {
    return (
      <>
        <NoEmployeeListFound />
        <AddEmployeeModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
        />
      </>
    );
  }

  return (
    <Box width="100%">
      {/* Add Employee Button */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          onClick={() => setOpenAddModal(true)}
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": {
              backgroundColor: BRAND_HOVER
            },
            textTransform: "none"
          }}
        >
          {t("add-new-employee", "Add New Employee")}
        </Button>
      </Box>

      {/* Employee Table */}
      <EmployeeTable
        employees={storesEmployees}
        title={t("store-employees", "Store Employees")}
        showPhoneColumn={false}
      />

      {/* Add Employee Modal */}
      <AddEmployeeModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
    </Box>
  );
};

export default StoreEmployeeList;
